module.exports = __webpack_public_path__ + "static/media/cap1_01a-mob.d3a0b6ee.jpg";